<template>
  <div class="rb-ob-form rb-match-page">
    <header>
      <h1 class="rb-ob-title">{{ $t('intake.matchExpiredTitle') }}</h1>
    </header>

    <div class="rb-ob-status-panel">
      <p class="rb-match-outcome-body">{{ $t('intake.matchExpiredBody') }}</p>
    </div>

    <div class="rb-ob-actions">
      <button class="rb-ob-submit" type="button" @click="refreshMatches">
        {{ $t('intake.matchRefreshAction') }}
      </button>
      <p class="rb-ob-status" role="status" aria-live="polite"></p>
      <div class="rb-ob-trust">
        <p>{{ $t('intake.trustPath') }}</p>
        <p>{{ $t('authUi.familyNote') }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MatchExpiredStep',
  methods: {
    refreshMatches() {
      this.$router.push({
        name: 'intakeMatching',
        params: {lang: this.$route.params.lang || 'fa'},
      })
    },
  },
}
</script>
